import { v4 as uuidv4 } from 'uuid';

export function uniqId(): string {
  return uuidv4();
}
